import { useState } from 'react';
import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import BasePrimaryNavItem from './BasePrimaryNavItem';
import { userHasRole } from 'src/utils/userHelpers';

declare interface Props {
  isPopover?: boolean;
}

const AdminItem: FC<React.PropsWithChildren<Props>> = (props) => {
  const [open, setOpen] = useState<boolean>(false);

  const isSalesManager = userHasRole(['Sales Manager']);

  if (!isSalesManager) {
    return null;
  }

  const menu = {
    section: 'Admin',
    items: [
      {
        title: 'CH Robinson',
        path: '/admin/chrobinson',
      },
      {
        title: 'Max Discount Raw',
        path: '/admin/maxdiscountraw',
      },
      {
        title: 'Max Discount Summary',
        path: '/admin/maxdiscountsummary',
      },
    ],
  };

  const handleClose = () => {
    setOpen(!open);
  };

  const content = (
    <>
      <p className="global-nav__section-title">{menu.section}</p>
      <div className="global-nav__item">
        {menu.items.map((item, index) => {
          return (
            <div className="global-nav__item-link" key={index}>
              <RouterLink to={item.path} key={index} onClick={() => handleClose()}>
                {item.title}
              </RouterLink>
            </div>
          );
        })}
      </div>
    </>
  );

  return (
    <BasePrimaryNavItem anchorEl={menu.section} isPopover={props.isPopover} isOpen={open}>
      {content}
    </BasePrimaryNavItem>
  );
};

export default AdminItem;
